<template>
    <div class="noticeDetailContent">
        <!-- 面包屑 -->
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/notice/notice' }">更多公告</el-breadcrumb-item>
                <el-breadcrumb-item>公告详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="noticeBox">
            <div class="noticeTopBox column">
                <div class="noticeTopTitle">{{ noticeDetail.title }}</div>
                <div class="noticeTopTime">{{ noticeDetail.create_time }}</div>
            </div>
            <div class="noticeDetail">
                <div v-html="noticeDetail.detail"></div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                noticeDetail: {}
            }
        },
        mounted(){
            this.getNoticeDetail()
        },
        methods: {
            // 获取公告详情
            getNoticeDetail(){
                this.request.get("index/notice/info",{
                    params:{
                        id: this.$route.query.id
                    }
                })
                .then(res=>{
                    this.noticeDetail = res.data
                })
            },
        }
    }
</script>
<style lang="less" scoped>
    .noticeDetailContent{
        background: #F7F8FA;
        padding-bottom: 50px;
        .noticeBox{
            width: 1160px;
            padding: 0 36px 50px 36px;
            background: #fff;
            border-radius: 8px;
            margin: 0 auto;
            border-top: 2px solid #0F59FE;
            .noticeTopBox{
                padding: 36px 0 26px 0;
                border-bottom: 1px solid #E6E7EB;
                .noticeTopTitle{
                    font: 24px/32px "Microsoft YaHei";
                }
                .noticeTopTime{
                    font: 14px/16px "Microsoft YaHei";
                    color: #ADACB1;
                    padding-top: 10px;
                }
            }
            .noticeDetail{
                padding: 30px 0;
            }
        }
    }
</style>